import { API_URL } from '../../config';

export function getAuthToken() {
  return localStorage.getItem('token');
}

/**
 * Kudos is one space (ADR-025). Companies are labels on people, so there is no
 * organisation to pick: every request runs in the Kudos space, and the server
 * ignores any organisation header.
 */
export const PLATFORM_ORG_ID = 'org-default-000-0000-000000000001';

export function getActiveOrgId(): string {
  return PLATFORM_ORG_ID;
}

/** Clears what the old organisation switcher left in the browser. */
export function clearLegacyOrgState() {
  try {
    ['activeOrgId', 'viewingOrgName', 'viewingPreviousOrgId', 'pre_impersonation_org'].forEach((k) => localStorage.removeItem(k));
  } catch {
    // Storage unavailable: nothing to clear.
  }
}

export function createAuthHeaders(extraHeaders: Record<string, string> = {}): Record<string, string> {
  const token = getAuthToken();

  const headers: Record<string, string> = token
    ? { Authorization: `Bearer ${token}`, ...extraHeaders }
    : { ...extraHeaders };

  return headers;
}

/**
 * Drops the cookie images and files are loaded with (MediaSession on the server).
 * Sent with keepalive so it still goes out while the page navigates to sign-in.
 */
export function signOutMediaSession() {
  try {
    fetch(`${API_URL}/api/auth/media-session`, { method: 'DELETE', keepalive: true, credentials: 'same-origin' })
      .catch(() => undefined);
  } catch {
    // Nothing to clear without a network; the cookie expires with the session anyway.
  }
}
